import i18n from '@/i18n'
import BlankLayout from '../../layout/blankLayout.vue'
import JobPostList from './list.vue'
import HistoryList from './pointChangeHistory.vue'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'

const pathPrefix = '/v-admin/company-admin/job-board-point-dashboard'

const routes = [
  {
    name: 'companyAdminJobBoardPointDashboardIndex',
    path: `${pathPrefix}/index`,
    component: JobPostList,
    meta: {
      titleI18nKey: 'admin.company.jobBoardPointDashboard.title.index',
      menu: {
        get label () {
          return i18n.t('admin.company.jobBoardPointDashboard.menu.index')
        },
        group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
      },
      isNewPage: true
    }
  },
  {
    name: 'companyAdminJobBoardPointDashboardHistory',
    path: `${pathPrefix}/history/:companyId`,
    component: HistoryList,
    meta: {
      titleI18nKey: 'admin.company.jobBoardPointDashboard.title.history',
      menu: {
        get label () {
          return i18n.t('admin.company.jobBoardPointDashboard.menu.history')
        },
        hiddenInNewLayout: true,
        group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
      },
      isNewPage: true
    }
  }
]

const jobBoardPointRoute = {
  name: 'companyAdminJobBoardPointDashboard',
  path: `${pathPrefix}`,
  component: BlankLayout,
  redirect: `${pathPrefix}/index`,
  meta: {
    permission: ['PREMIUM_JOB_BOARD_POINT_DASHBOARD', 'PERM_HR_JOB_BOARD_POINT_DASHBOARD'],
    titleI18nKey: 'admin.company.jobBoardPointDashboard.title.index',
    menu: {
      get label () {
        return i18n.t('admin.company.jobBoardPointDashboard.menu.index')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    },
    isAllInclude: true,
    isNewPage: true
  },
  children: routes
}

export default jobBoardPointRoute
